import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { Box, Button, Grid2 } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useMediaQuery from "@mui/material/useMediaQuery";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import consts from "../../constant";
import Header from "../Header/Header";
import "./UserList.css";
import {Tooltip } from "@mui/material";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
const drawerWidth = 260;

const UserList = () => {
  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  const back = useNavigate();
  // const detail = useLocation();

  const [reason, setreason] = useState();

  const navigate = useNavigate();
  const Navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setloading] = useState(true);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPages] = useState(0);
  const [detail, setDetail] = useState([]);
  const [showDetail, setShowDetail] = useState(false);


  const [search, setSearch] = useState("");

  const getUser = async () => {
    let payload = {};

    if (search) {
      payload = { search };
    }

    try {
      const res = await Axios.post(
        `${consts.BackendUrl}/admin/getAllUserData?limit=${limit}&page=${page}`,
        payload,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Content-Type, Authorization",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: localStorage.getItem("adminToken"),
          },
        }
      );

      if (res?.data?.result?.docs?.length > 0) {
        setData(res.data.result.docs);
        setTotalPages(res.data.result.totalPages);
      } else {
        setData([]);
        console.log("Data Not Found");
      }
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("adminToken")) {
      getUser();
    } else {
      Navigate(`${consts.route + '/login'}`);
    }
  }, [limit, page]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    getUser(); // Call API when search is submitted
  };

  const [filtersReset, setFiltersReset] = useState(false)


  const handleReset = () => {
    setSearch("");
    setFiltersReset(true)

  };

  useEffect(() => {
    if (filtersReset) {
      getUser();
      setFiltersReset(false);
    }
  }, [filtersReset]);

  const handleDownload = () => {
    const formData = data.map((item, index) => ({
      "S.No": index + 1,
      Name: item.name,
      Email: item.email,
      "Email Verify": item.email_verify ? "Verified" : "Not Verified",
      "2FA": item.twoFA ? "Enabled" : "Disabled",
      "KYC Verify": item.kyc_verify ? "Verified" : "Not Verified",
      Role: item.role,
      "Is Google": item.isGoogle ? "Yes" : "No",
      "Profile Picture": item.profilePicture ? "Yes" : "No",
    }));
    const ws = XLSX.utils.json_to_sheet(formData, { origin: "A2" });

    const title = [["User Data Report"]];
    XLSX.utils.sheet_add_aoa(ws, title, { origin: "A1" });

    const mergeRange = {
      s: { r: 0, c: 0 },
      e: { r: 0, c: Object.keys(formData[0]).length - 1 },
    };
    if (!ws["!merges"]) ws["!merges"] = [];
    ws["!merges"].push(mergeRange);

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "4F81BD" } },
    };
    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
    };

    ws["A1"].s = titleStyle;

    const headerRange = Object.keys(formData[0]).map((_, colIndex) =>
      XLSX.utils.encode_cell({ r: 1, c: colIndex })
    );
    headerRange.forEach((cell) => (ws[cell].s = headerStyle));

    ws["!cols"] = Object.keys(formData[0]).map((key) => ({
      wch: key.length + 10,
    }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "UserDataReport.xlsx");
  };

  const array = [
    "S.no",
    "Data And Time",
    "Name",
    "Email",
    "Email_Verify",
    "kyc_Verify",
    "Action",
  ];
  const handleView = () => {
    navigate("/userlist/userlist-view");
  };
  const Resume = (data) => {
    console.log(data, "data1");

    Axios.post(
      `${consts.BackendUrl}/users/yarn`,
      { id: data._id, block: data.block },
      {
        headers: {
          Authorization: localStorage.getItem("adminToken"),
        },
      }
    )
      .then((res) => {
        toast.success(`${res?.data.message}`, {
          duration: 4000,
          position: "top-center",
          style: {
            padding: "1rem",
            fontSize: "15px",
            color: "green",
            fontWeight: "bold",
          },
          className: "",

          // Custom Icon
          icon: "👏",

          // Change colors of success/error/loading icon
          iconTheme: {
            primary: "#000",
            secondary: "#fff",
          },

          // Aria
          ariaProps: {
            role: "status",
            "aria-live": "polite",
          },
        });

        setTimeout(() => {
          // navigate("/kaaviExchangeAdmin/userlist")
          setShowDetail(false);
          getUser();
        }, 2600);
      })
      .catch((err) => {
        toast.error(`${err?.response?.data?.message}`, {
          duration: 4000,
          position: "top-center",

          // Styling
          style: {
            backgroundColor: "#fc1922",
            padding: "1rem",
            fontSize: "18px",
            color: "white",
            fontWeight: "bold",
          },
          className: "",

          // Custom Icon
          icon: "",

          // Change colors of success/error/loading icon
          iconTheme: {
            primary: "#000",
            secondary: "#fff",
          },

          // Aria
          ariaProps: {
            role: "status",
            "aria-live": "polite",
          },
        });
      });
  };
  return (
    <div className="UserList">
      <Box sx={{ display: lg ? "flex" : "block" }}>
        <Header />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 5,
            width: { lg: `calc(100% - ${drawerWidth}px)` },
            marginTop: "50px",
          }}
        >
          <h2 style={{ color: 'white' }} >Users List</h2>
          <Grid2 container spacing={2}>
            <Grid2
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <form onSubmit={handleSearchSubmit}>
                <input
                  id=""
                  style={{
                    width: "300px",
                    height: "40px",
                    border: "1px solid white",
                    backgroundColor: "transparent",
                    color: "white",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                  type="text"
                  value={search}
                  onChange={handleSearch}
                  placeholder="Search users..."
                />

                <Button
                  style={{ height: "40px", marginLeft: "10px" }}
                  variant="contained"
                  type="submit"
                >
                  Search
                </Button>
                <Button
                  style={{ height: "40px", marginLeft: "10px" }}
                  variant="contained"
                  type="button"
                  onClick={handleReset}
                >
                  Reset
                </Button>
                <Button
                  onClick={handleDownload}
                  type="download"
                  style={{ height: "40px", marginLeft: "10px" }}
                  variant="contained"
                >
                  Excel To Export
                </Button>
              </form>
            </Grid2>

            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              {showDetail ? (
                <>
                  <div>
                    <Button
                      variant="contained"
                      onClick={() => setShowDetail(false)}
                    >
                      Back
                    </Button>
                  </div>
                  <div className="custom_table">
                    <TableContainer sx={{ background: "#10212C" }}>
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell align="left">Email</TableCell>
                            <TableCell align="center">
                              Email Verify Status
                            </TableCell>
                            <TableCell align="center">Kyc Verify</TableCell>
                            <TableCell align="center">Total Balance</TableCell>
                            <TableCell align="center">Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow
                            key={detail?.name}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {detail?.name}
                            </TableCell>
                            <TableCell align="center">
                              {detail?.email}
                            </TableCell>

                            <TableCell align="center">
                              {detail?.email_verify == "true" ? (
                                <span>Verified</span>
                              ) : (
                                <span>Not Verified</span>
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {detail?.kyc_verify == "true" ? (
                                <span>Verified</span>
                              ) : (
                                <span>Not Verified</span>
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {detail?.TotalBalance
                                ? detail?.TotalBalance.toFixed(6)
                                : 0}
                            </TableCell>
                            <TableCell align="center">
                              {!detail?.block ? (
                                <Button
                                  variant="contained"
                                  color="error"
                                  onClick={() => {
                                    // handleClose()

                                    Resume({ _id: detail?._id, block: true });
                                    // window.location.reload(true)
                                  }}
                                >
                                  Block
                                </Button>
                              ) : (
                                <Button
                                  variant="contained"
                                  color="success"
                                  onClick={() => {
                                    Resume({ _id: detail?._id, block: false });
                                    // window.location.reload(true)
                                  }}
                                >
                                  UnBlock
                                </Button>
                              )}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </>
              ) : (
                <div className="custom_table">
                  <TableContainer sx={{ background: "#000" }}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          {array.map((item) => (
                            <TableCell
                              style={{ color: "white" }}
                              align="center"
                            >
                              {item}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data?.map((value, index) => (
                          <TableRow
                            key={value.name}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {limit * (page - 1) + index + 1}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {value?.createdAt ? new Date(value.createdAt).toLocaleString('en-IN') : "N/A"}

                            </TableCell>

                            <TableCell style={{ color: "white" }} align="center">
                              {value?.name ? value?.name : "User"}
                            </TableCell>

                            <TableCell style={{ color: "white" }} align="center">{value?.email}</TableCell>
                            <TableCell align="center">
                              {value.verified == true ? (
                                <CheckCircleOutlineOutlinedIcon
                                  sx={{ fill: "green" }}
                                />
                              ) : (
                                <CancelOutlinedIcon sx={{ fill: "red" }} />
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {value.kyc_verify == true ? (
                                <CheckCircleOutlineOutlinedIcon
                                  sx={{ fill: "green" }}
                                />
                              ) : (
                                <CancelOutlinedIcon sx={{ fill: "red" }} />
                              )}
                            </TableCell>

                            <TableCell align="center">
                              <Tooltip
                                title="View"
                                arrow
                                placement="top"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "purple", // Violet background
                                      color: "white", // White text
                                      fontSize: "14px", // Adjust text size
                                      fontWeight: "bold",
                                      padding: "6px 12px" // Adjust padding
                                    }
                                  },
                                  arrow: {
                                    sx: {
                                      color: "purple" // Match arrow color with tooltip
                                    }
                                  }
                                }}
                              >
                                <Button
                                  variant="contained"
                                  onClick={() => {
                                    navigate(`/${consts?.route + "/userlistview"}`, { state: { value } });
                                  }}
                                  className="edit-btn"
                                >
                                  <VisibilityOutlinedIcon />
                                </Button>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Pagination
                    className="pagnation"
                    count={totalPage}
                    page={page}
                    onChange={(event, value) => {
                      setPage(value);
                    }}
                    variant="outlined"
                    color="#fff"
                    shape="rounded"
                    sx={{ background: "#000" }}
                  />
                </div>
              )}
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </div>
  );
};

export default UserList;
